import Vue from 'vue'

const state = {
    notificaciones: [],
    cantNotificacionesNuevas: 0
}

const getters = {
    getNotificaciones: state => {
        return state.notificaciones;
    },

    getCantNotificacionesNuevas: state => {
        return state.cantNotificacionesNuevas;
    }
}

const mutations = {
    agregarNotificacion: (state, payload) => {
        state.notificaciones.push(payload);
    },

    setNotificacionesNuevas: (state, payload) => {
        state.cantNotificacionesNuevas = payload;
    }
}

const actions = {
    agregarNotificacion({ commit, state, rootState }, payload) {
        var cantNotificaciones = state.cantNotificacionesNuevas + 1;
        commit('agregarNotificacion', payload)
        commit('setNotificacionesNuevas', cantNotificaciones)
    },

    setNotificacionesNuevas({ commit, state, rootState }, payload) {
        commit('setNotificacionesNuevas', payload)
    }
}

export default {
    state,
    getters,
    mutations,
    actions
}